/**
 * Plausible custom event tracking.
 * Plausible est chargé via script dans index.html.
 * Cette fonction est no-op si Plausible n'est pas chargé (dev sans script, adblock).
 */

declare global {
  interface Window {
    plausible?: (eventName: string, options?: { props?: Record<string, string> }) => void;
  }
}

export function trackEvent(eventName: string, props?: Record<string, string>): void {
  try {
    if (typeof window !== 'undefined' && window.plausible) {
      window.plausible(eventName, props ? { props } : undefined);
    }
  } catch {
    // Silencieux -- le tracking ne doit jamais casser l'app
  }
}
